<template>
  <div>{{ currentTime }}</div>
</template>

<script>
export default {
  name: 'SystemTime',
  data () {
    return {
      currentTime: new Date().toLocaleTimeString()
    }
  },
  created () {
    this.updateTime()
  },
  methods: {
    updateTime () {
      setInterval(() => {
        const date = new Date()
        const userTimezoneOffset = Math.abs(date.getTimezoneOffset() * 60000)
        this.currentTime = new Date(date.getTime() - userTimezoneOffset).toLocaleTimeString()
      }, 1000)
    }
  }
}
</script>

<style scoped>
div {
  font-size: 0.875rem;
  padding: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SystemTime.vue